import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'truncate',
  standalone: false
})
export class TruncateStringPipe implements PipeTransform {
  transform(value: string, charNumber: number): string {
    return value?.length > charNumber ? value.slice(0, charNumber).concat('...') : value;
  }
}
